module.exports = __webpack_public_path__ + "static/media/become-img-4.49f99223.png";